<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="row" v-if="!loading">
            <div class="col-lg-12 mb-4">
                <ApplicantInfoBlock
                    :user="dataApplicantInfoBlock"
                    :deactivatingApplicant="deactivatingApplicant"
                    :editing-applicant-id="editApplicantId"
                ></ApplicantInfoBlock>
            </div>
            <div class="col-lg-12 mb-4">
                <ApplicantTabsContainer
                    :user="user"
                    :viewAdminsNotes="viewAdminsNotes"
                    :editingNote="editingNote"
                    :viewRates="viewRates"
                > </ApplicantTabsContainer>
            </div>
        </div>
    </div>



</template>

<script>
import ApplicantInfoBlock from "./ApplicantInfoBlock.vue";
import ApplicantTabsContainer from "./ApplicantTabsContainer.vue";
import ApplicantsServices from "./services/ApplicantsServices";

export default {
    name: 'ApplicantPage',
    components: {ApplicantTabsContainer, ApplicantInfoBlock},
    props: {
        applicantId: Number,
        viewAdminsNotes: Boolean,
        editingNote: Boolean,
        deactivatingApplicant: Boolean,
        viewRates: Boolean,
        editApplicantId: Boolean,
    },
    data() {
        return {
            loading: true,
            user: {},
            dataApplicantInfoBlock: {
                date_applied: null,
                applicant_id: null,
                id: null,
                name: null,
                last_name: null,
                ssn: null,
                email: null,
                position: {
                    title: null
                },
                cell_number: null,
                user_address: {
                    city: null,
                    states: {
                        name: null
                    },
                },
                avatar: null,
                tags: [],
                status: null
            },
        }
    },
    methods: {
        async getUserInfo() {
            try {
                const {data: userInfo} = await ApplicantsServices.getUserInfo(this.applicantId)
                this.user = userInfo
                this.loading = false
                Object.keys(this.dataApplicantInfoBlock).forEach((key) => {
                    if (userInfo.hasOwnProperty(key)) {
                        this.dataApplicantInfoBlock[key] = userInfo[key];
                    }
                });
                this.userStatus = this.user.status
            } catch (error) {
                this.$handleErrors(error);
            }
        },
    },

    mounted() {
        this.getUserInfo();
    }
}

</script>

<style scoped>

</style>
